function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    viewBox: "0 0 30 30",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21,12  H9V9c0-3.314,2.686-6,6-6h0c3.314,0,6,2.686,6,6V12z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,11H6c-1.105,0-2,0.895-2,2v12c0,1.105,0.895,2,2,2h18c1.105,0,2-0.895,2-2V13C26,11.895,25.105,11,24,11z M15,21  c-1.105,0-2-0.896-2-2c0-1.105,0.895-2,2-2s2,0.895,2,2C17,20.104,16.105,21,15,21z M21,21c-1.105,0-2-0.896-2-2  c0-1.105,0.895-2,2-2s2,0.895,2,2C23,20.104,22.105,21,21,21z M9,21c-1.105,0-2-0.896-2-2c0-1.105,0.895-2,2-2s2,0.895,2,2  C11,20.104,10.105,21,9,21z",
    style: {
      fill: "#ffffff",
      stroke: "#ffffff",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), "    \n/>");
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordLight);
export default __webpack_public_path__ + "static/media/password_light.ba6f00a1cc09f924ad721870139f01da.svg";
export { ForwardRef as ReactComponent };